import React from 'react';
import PropTypes from 'prop-types';

import styles from './playerChip.scss';

// Shared removable player pill for the SavedLists surfaces (MultiPlayerSearch Step-1 field,
// AddPlayerToListModal Step-2 chips strip). The caller passes the chip's own `data-testid` (e.g.
// `add-player-search.chip-101`) so each surface keeps its exact contract; `.name` / `.remove`
// suffixes derive from it.
const PlayerChip = ({ 'data-testid': dataTestId, name, onRemove }) => (
    <span className={styles.chip} data-testid={dataTestId}>
        <span className={styles.chipName} title={name} data-testid={dataTestId && `${dataTestId}.name`}>
            {name}
        </span>
        <button
            type="button"
            className={styles.chipRemove}
            onClick={onRemove}
            aria-label={`Remove ${name}`}
            data-testid={dataTestId && `${dataTestId}.remove`}
        >
            <i className="utr utr-close" />
        </button>
    </span>
);

PlayerChip.propTypes = {
    'data-testid': PropTypes.string,
    name: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
};

PlayerChip.defaultProps = {
    'data-testid': null,
};

export default PlayerChip;
